import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CandidateEntityModel } from 'app/interfaces';

import * as moment from 'moment';

@Component({
  selector: 'app-candidate-detail',
  templateUrl: './candidate-detail.component.html',
  styleUrls: ['./candidate-detail.component.scss']
})
export class CandidateDetailComponent implements OnInit {
  @Input() candidate!: CandidateEntityModel;
  @Input() isExternal!: boolean;
  @Input() showProcessStatusBtns!: boolean;

  @Output() changeProcessStatus: EventEmitter<any> = new EventEmitter<any>();

  get years() {
    return moment().diff(this.candidate.User.birth_date, 'years');
  }

  constructor() { }

  ngOnInit() {
  }

  emitChangeProcessStatus(processStatus: string) {
    this.changeProcessStatus.emit(processStatus);
  }

}
